import { render, staticRenderFns } from "./ModernAccountTrigger.vue?vue&type=template&id=752506b3&"
import script from "./ModernAccountTrigger.vue?vue&type=script&lang=js&"
export * from "./ModernAccountTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports